import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Destroy, SortExpression, tr, Key } from '@kpd/framework-ngx';
import { Permission } from 'app/shared/models/permission';
import { SortEvent } from 'primeng/components/common/sortevent';
import { PermissionService } from 'app/shared/services/permission.service';
import { TableController } from 'app/shared/utils/table-controller';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';
import { Permissionset } from 'app/shared/models/permissionset';

@Component({
  selector: 'app-permission-details-permissionsets',
  templateUrl: './permission-details-permissionsets.component.html',
})
export class PermissionDetailsPermissionsetsComponent extends TableController implements OnInit, OnChanges, OnDestroy {
  @Input()
  permission: Permission;
  @Destroy()
  destroy$: any;
  readOnlyMode = true;
  selectedKeys: Key<string>[] = [];
  selection = [];
  sortExpression: SortExpression;
  columnsConfig = this.createColumnsConfig();
  saveErrors: string[] = [];
  @Output()
  permissionSetCountChanged = new EventEmitter<number>();

  constructor(private permissionFacade: PermissionFacade, private permissionService: PermissionService) {
    super();
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.permission) {
      this.selectedKeys = [];
      this.selection = [];
      this.saveErrors = [];
      if (
        changes.permission.currentValue &&
        (changes.permission.currentValue as Permission).key &&
        (changes.permission.currentValue as Permission).key.isDefined()
      ) {
        this.loadPermissionPermissionSets((changes.permission.currentValue as Permission).key.id);
      }
    }
  }

  loadPermissionPermissionSets(id: string): void {
    this.permissionFacade.detailLoadingStarted();
    this.permissionService.getPermissionSets(id).subscribe(
      (permissionSets) => {
        const uniqueSetNames = Array.from(new Set(permissionSets.map((set) => set.name)));

        this.items = uniqueSetNames.map((name) => permissionSets.find((p) => p.name === name) as Permissionset);
        this.permissionSetCountChanged.emit(uniqueSetNames.length);
        this.permissionFacade.detailLoadingFinished();
      },
      () => {
        this.permissionFacade.detailLoadingFinished();
      },
    );
  }

  onSort(event: SortEvent): void {
    this.sortExpression = new SortExpression();
    this.sortExpression.fieldName = event.field as string;
    this.sortExpression.sortOrder = event.order as number;
  }

  createColumnsConfig(): any[] {
    return [
      { field: 'name', header: tr('Name'), width: '40%' },
      { field: 'description', header: tr('Description'), width: '40%' },
      { field: 'type', header: 'Type', type: 'type', width: '200px' },
      { field: 'isKpdSet', header: 'KPD', type: 'KPD', width: '65px' },
    ];
  }

  hasAssign(itemType: string): boolean {
    return itemType === 'both' || itemType === 'assign';
  }

  hasUse(itemType: string): boolean {
    return itemType === 'both' || itemType === 'use';
  }
  // tslint:disable-next-line:no-unused-expression
  ngOnDestroy(): void {}
}
